import React from 'react';
import { useAuth } from './hooks/auth/use-auth';
import GlobalProviders from './providers';
import { RouterSwitch } from './routes/router-switch';
import { UnauthenticatedRouter } from './routes/unauthenticated-router';
import './styles/main.scss';
import { EnvironmentType } from './types/common';

declare global {
  interface Window {
    configuration: EnvironmentType;
    loglevel: number;
    chrome: any;
    opr?: any;
  }
}

const DefaultRouterApp: React.FC = () => (
  <GlobalProviders>
    <RouterSwitch />
  </GlobalProviders>
);

export const AppLocal: React.FC = () => <DefaultRouterApp />;

export const App: React.FC = () => {
  const { keycloak } = useAuth();

  return <>{keycloak.authenticated ? <DefaultRouterApp /> : <UnauthenticatedRouter />}</>;
};
